export default __webpack_public_path__ + "static/media/filters.74c68293.mp4";